<template>
  <div>
    <mf-card-container v-if="showUngroupedTable" :title="title" :hide-card-shadow="hideCardShadow">
      <mf-info-card v-if="isIndustryCampaign && ungroupedProducts.length > 0" variant="success" :v-html="industryRebateWarning" icon="payments" />
      <take-pay-table
        :ref="offerSalesType"
        class="mt-4"
        type="ungrouped"
        :products="ungroupedProducts"
        :validations="$v"
        :headers="headers"
        :helpers="helpers"
        :repeated-skus="repeatedSkus"
        :search="search"
        :is-disabled-in-rules="isDisabledInRules"
        :is-industry-campaign="isIndustryCampaign"
        :tooltip-message="tooltipMessage"
        :disabled="disabled"
        :campaign="campaign"
        @remove-item="removeItem"
      />
    </mf-card-container>

    <div v-if="showGroupedTable">
      <h2 :class="showUngroupedTable ? 'pt-8' : ''" class="ma-0 pb-0 offers-title">Grupos na oferta</h2>
      <p class="offers-subtitle pt-3">
        {{ groupDescription }}
      </p>

      <group-card
        v-for="(group, index) in groupedProducts"
        :key="group._id"
        offer-sales-type="takepay_offer_sales"
        :group="group"
        :headers="headers"
        :helpers="helpers"
        :repeated-skus="repeatedSkus"
        :validations="$v"
        :group-index="index"
        :search="search"
        :is-disabled-in-rules="isDisabledInRules"
        :is-industry-campaign="isIndustryCampaign"
        :tooltip-message="tooltipMessage"
        :disabled="disabled"
        :campaign="campaign"
        @remove-item="removeItem"
        @remove-group="removeGroup(group._id)"
        @change-group-exhibition="changeGroupExhibition($event, group._id)"
      />
    </div>
  </div>
</template>

<script>
import GroupCard from '../GroupCard.vue'
import TakePayTable from './TakePayTable.vue'

import { required, requiredIf } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { eansValidation, takeAndPayValidation, distributionLimitValidation } from '@/modules/campanhas/gestao-ofertas-v2/helpers/validators.js'

import { offerSalesTablesContainer } from '../../../mixins/offer-sales-tables-container'
import intelligentDistributionMixin from '../../../mixins/intelligent-distribution'
export default {
  name: 'TakePay',
  components: {
    GroupCard,
    TakePayTable,
  },
  mixins: [offerSalesTablesContainer, intelligentDistributionMixin],
  computed: {
    offerSalesType() {
      return 'takepay_offer_sales'
    },
    title() {
      return this.ungroupedProducts.length === 1
        ? '1 produto desagrupado com leve e pague'
        : `${this.ungroupedProducts.length} produtos desagrupados com leve e pague`
    },
    headers() {
      let headers = [
        {
          text: '',
          value: 'expandAction',
          width: '2%',
          sortable: false,
        },
        {
          text: '',
          value: 'image',
          width: '5%',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '12%',
          sortable: false,
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '30%',
          sortable: false,
        },
        {
          text: 'Leve',
          value: 'take',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Pague',
          value: 'pay',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Max CPF',
          value: 'maximum_per_client',
          width: '8%',
          sortable: false,
          tooltip: this.isMercapromoCampaign ? 'Máximo de vezes que um cliente poderá ativar a oferta' : null,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          width: '',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ]

      if (this.isIntelligentDistributionEnabled) {
        const statusIndex = headers.findIndex((header) => header.value === 'status')
        if (statusIndex >= 0) {
          headers.splice(statusIndex, 0, {
            text: 'Limite de ofertas',
            value: 'distribution_limit',
            width: '12%',
            sortable: false,
          })
        }
      }

      return headers
    },
  },
  validations() {
    const fields = {
      required: requiredIf(function () {
        return this.allInputsRequired
      }),

      $each: {
        sku: requiredIf(function (group) {
          return !group.products
        }),
        name: { required, notOnlySpace },
        eans: {
          eansValidation,
        },
        take: { takeAndPayValidation },
        pay: { takeAndPayValidation },
        distribution_limit: { distributionLimitValidation: distributionLimitValidation(this) },
        products: {
          $each: {
            eans: {
              eansValidation,
            },
            name: { required, notOnlySpace },
          },
        },
      },
    }
    return {
      ...(this.ungroupedProducts.length > 0
        ? {
            ungroupedProducts: { ...fields },
          }
        : {}),

      ...(this.groupedProducts.length > 0
        ? {
            groupedProducts: { ...fields },
          }
        : {}),
    }
  },
}
</script>

<style lang="scss" scoped>
.offers-subtitle {
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.4px;
  color: $cinza-0;
  max-width: 930px;
}

.offers-title {
  font-size: 26px;
  font-weight: 700;
  color: $cinza-d10;
}
</style>
